"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberMonthlyOverviewMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const index_1 = require("./index");
const MemberMonthlyOverviewMobile = ({ membersOverview, onMemberClick }) => {
    const onClick = (id, isDisabled) => () => {
        if (isDisabled)
            return;
        onMemberClick(id);
    };
    return ((0, jsx_runtime_1.jsx)(Container, { children: membersOverview.map((overview, idx) => ((0, jsx_runtime_1.jsxs)(Card, { isDisabled: overview.isDisabled, children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: `${idx + 1}.` }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { onClick: onClick(overview.id, overview.isDisabled), children: overview.name }, void 0), overview.events.map((event, idx) => {
                            const isFromDateBold = !!(event.from && event.reasonIn);
                            const isToDateBold = !!(event.to && event.reasonOut);
                            return ((0, jsx_runtime_1.jsxs)(Event, { isDisabled: overview.isDisabled, children: [(0, jsx_runtime_1.jsx)(Date, { isBold: isFromDateBold, children: event.from }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: event.reasonIn }, void 0), (0, jsx_runtime_1.jsx)(Date, { isBold: isToDateBold, children: event.to }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: event.reasonOut }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(index_1.Tag, { className: "subscription", subscription: event.subscriptionType, isDisabled: overview.isDisabled, children: event.subscriptionType }, void 0) }, void 0)] }, event.subscriptionType + idx));
                        })] }, void 0)] }, overview.name))) }, void 0));
};
exports.MemberMonthlyOverviewMobile = MemberMonthlyOverviewMobile;
const Container = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: ${({ theme }) => theme.spacings.m};
  padding: ${({ theme }) => theme.spacings.m};

  & > div:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacings.s};
  }

  & > div:last-of-type > div > div {
    border-bottom: none;
  }
`;
const Card = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1rem 1fr;
  grid-column-gap: 1rem;

  h4,
  p {
    margin-bottom: 0;
  }

  & h4 {
    color: ${({ isDisabled, theme }) => isDisabled ? theme.colors.silverLighten60 : theme.colors.greyBase};
    font-weight: 500;
  }

  & > div > div {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten70};
    display: grid;
    grid-column-gap: ${({ theme }) => theme.spacings.xs};
    grid-row-gap: ${({ theme }) => theme.spacings.xxxs};
    grid-template-columns: 1fr 2fr;
    grid-template-rows: repeat(3, 1fr);
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};
  }

  .subscription {
    margin: 0;
    width: unset;
  }
`;
const Event = styled_components_1.default.div `
  & > * {
    color: ${({ isDisabled, theme }) => isDisabled ? theme.colors.silverLighten60 : theme.colors.greyBase};
  }
`;
const Date = (0, styled_components_1.default)(typography_1.P) `
  font-weight: ${({ isBold }) => (isBold ? 600 : 400)};
`;
//# sourceMappingURL=MemberMonthlyOverviewMobile.js.map